import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	gettingStarted: {
		id: 'ai-mate.getting-started-tour.getting-started',
		defaultMessage: 'Getting Started',
		description: 'Getting started button that will begin the spotlight tour',
	},
	back: {
		id: 'ai-mate.getting-started-tour.back',
		defaultMessage: 'Back',
		description: 'Back button for spotlight',
	},
	done: {
		id: 'ai-mate.getting-started-tour.done',
		defaultMessage: 'Done',
		description: 'Done button for spotlight',
	},
	next: {
		id: 'ai-mate.getting-started-tour.next',
		defaultMessage: 'Next',
		description: 'Next button for spotlight',
	},
	stepIndicator: {
		id: 'ai-mate.getting-started-tour.indicator',
		defaultMessage: '{stepNumber} of {totalSteps}',
		description:
			'Current step in the spotlight tour, where {stepNumber} is the current step number and {totalSteps} is the total number of steps',
	},
	stepOneTitle: {
		id: 'ai-mate.getting-started-tour.step-one.title',
		defaultMessage: 'Add work from anywhere',
		description: 'Title for the first spotlight',
	},
	stepOneDescription: {
		id: 'ai-mate.getting-started-tour.step-one.description',
		defaultMessage:
			'Choose a template, upload a file, link a page, and more to power your creation.',
		description: 'Description for the first spotlight',
	},
	stepTwoTitle: {
		id: 'ai-mate.getting-started-tour.step-two.title',
		defaultMessage: 'Get unstuck on your prompt',
		description: 'Title for the second spotlight',
	},
	stepTwoDescription: {
		id: 'ai-mate.getting-started-tour.step-two.description',
		defaultMessage: 'Try an example or use them to jump-start your draft.',
		description: 'Description for the second spotlight',
	},
	stepThreeTitle: {
		id: 'ai-mate.getting-started-tour.step-three.title',
		defaultMessage: 'Talk to Rovo instead of typing',
		description: 'Title for the third spotlight',
	},
	stepThreeDescription: {
		id: 'ai-mate.getting-started-tour.step-three.description',
		defaultMessage: 'Use your voice to get started.',
		description: 'Description for the third spotlight',
	},
});
